import { GrowthBook } from '@growthbook/growthbook-react';
import { integrations } from 'config';

const gb = new GrowthBook({
  apiHost: integrations.growthbook.apiHost,
  clientKey: integrations.growthbook.clientKey,
  enableDevMode: integrations.deployment != 'production',
});

gb.init({ streaming: true });

export default gb;
